import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';

export function useImpersonationGuard() {
  const { isImpersonating } = useAuth();

  const guardWrite = (actionLabel: string = 'make changes') => {
    if (isImpersonating) {
      toast.error(
        `Cannot ${actionLabel} in View Only mode. End impersonation to make changes.`
      );
      return false;
    }
    return true;
  };

  return { isReadOnly: isImpersonating, guardWrite };
}
